export default __webpack_public_path__ + "static/media/ArrowFillDown.bfe1e0b6.svg";